import { RecensioneForm } from "@/features/recensioni";

export default function RecensionePage() {
  return <RecensioneForm />;
}
